import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'

import TitleWithRemark from 'components/common/TitleWithRemark'
import { useServiceClassifications } from 'utils/api/hooks'
import LinkItem from './LinkItem'

const MobileServiceItem = ({ selfConstruct }) => {
  const { data: classifications } = useServiceClassifications({
    displayVisible: selfConstruct.active ? 'all' : 'visible',
  })

  return (
    <>
      <Box display="flex" flexDirection="column">
        <TitleWithRemark variant="subtitle1" my={4}>
          熱門服務
        </TitleWithRemark>
        <Divider />

        <Box my={7.5}>
          {classifications &&
            classifications.map((data, idx) => (
              <LinkItem
                key={idx}
                href={`/vender?serviceItem=${data?._id}`}
                $isFirst={idx === 0}
              >
                {data.name}
              </LinkItem>
            ))}
        </Box>
      </Box>
    </>
  )
}

export default MobileServiceItem
